import React from 'react';
import {motion} from 'framer-motion';
import CtaButton from './CtaButton';
import Logo from './Logo';
import ProductMockup from './ProductMockup';

function Hero() {
  return (
    <header className="hero" id="top">
      <nav className="nav shell">
        <Logo />
        <a className="nav-link" href="#inside">See what is inside</a>
      </nav>

      <div className="hero-layout shell">
        <motion.div
          className="hero-copy"
          initial={{opacity: 0,y: 24}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.65}}
        >
          <p className="eyebrow">The 90-Day New Manager Toolkit</p>

          <h1>
            Your promotion didn't come with a manual.
            <em>Here is your toolkit.</em>
          </h1>

          <p className="hero-subhead">
            You were promoted because you were excellent at the work, but nobody trained you for the actual job of leading a team. Bridge the gap and step into your role with confidence using The 90-Day New Manager Toolkit.
          </p>

          <CtaButton>Get the Toolkit</CtaButton>
          <p className="trust-line">$69 · instant download · 7 files</p>
        </motion.div>

        <motion.div
          initial={{opacity: 0,scale: 0.96}}
          animate={{opacity: 1,scale: 1}}
          transition={{duration: 0.65,delay: 0.15}}
        >
          <ProductMockup hero />
        </motion.div>
      </div>
    </header>
  );
}

export default Hero;